import { render, staticRenderFns } from "./AdminUserManageStatusButton.vue?vue&type=template&id=456faf94"
import script from "./AdminUserManageStatusButton.vue?vue&type=script&lang=js"
export * from "./AdminUserManageStatusButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports